export default class EmailDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        this.attachments = [];
        this.id = null;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                description: null,
                subject: '',
                emailType: '',
                content: '',
                photos: [],
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.attachments = from.attachments;
            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    emailType: from.translations[element]?.emailType,
                    description: from.translations[element]?.description,
                    content: from.translations[element]?.content,
                    subject: from.translations[element]?.subject,
                    photos: from.translations[element]?.photos,
                };
            });
        } else {
            to = new EmailDetailsResponse();
        }
    }

    static copy(to, from) {
        //const to = new EmailDetailsResponse();
        EmailDetailsResponse.assign(from, to);
        return to;
    }
}
